import React from 'react';
import { observer } from 'mobx-react';

function Drawer({
	onClose,
	children,
	title,
	actionButtons,
	customHeader,
	showHeader = true
}) {
	return (
		<div className="drawer-wrapper">
			<div className="drawer">
				{showHeader && (
					<div className="drawer-header">
						{customHeader || (
							<>
								{title}
								{actionButtons}
								<button
									className="drawer-close-btn button-border-soft-medium is-icon-only"
									onClick={onClose}>
									<img src="/ats/icons/close-blue-icon.svg" alt="" />
								</button>
							</>
						)}
					</div>
				)}
				<div className="drawer-content">{children}</div>
			</div>
		</div>
	);
}

export default observer(Drawer);
